import { useLocalSearchParams } from "expo-router";

import { PublicSignatureSession } from "../../src/components/PublicSignatureSession";

export default function PublicSignatureRoute() {
  const params = useLocalSearchParams<{ token?: string | string[] }>();
  const token = Array.isArray(params.token) ? params.token[0] ?? "" : params.token ?? "";
  return <PublicSignatureSession token={token} />;
}
